import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Modal from '../components/Modal';
import { getUsersFromStorage, removeUser } from '../utils/storage';
import '../styles/UserListPage.css';

const UserListPage = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [userToUnbind, setUserToUnbind] = useState(null);
  const [pressTimer, setPressTimer] = useState(null);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = () => {
    const usersData = getUsersFromStorage();
    setUsers(usersData);
  };

  const handlePressStart = (user) => {
    const timer = setTimeout(() => {
      setUserToUnbind(user);
      setShowModal(true);
    }, 800);
    setPressTimer(timer);
  };

  const handlePressEnd = () => {
    if (pressTimer) {
      clearTimeout(pressTimer);
      setPressTimer(null);
    }
  };

  const handleUnbind = () => {
    if (userToUnbind) {
      removeUser(userToUnbind.id);
      loadUsers();
    }
    setShowModal(false);
    setUserToUnbind(null);
  };

  const handleViewReport = (userId) => {
    navigate(`/report/${userId}`);
  };

  const handleBookAppointment = (userId) => {
    alert('预约挂号功能开发中...');
  };

  const handleAddUser = () => {
    navigate('/bind');
  };

  return (
    <div className="page user-list-page">
      <Header title="中国近视防控大数据平台" showClose />

      <div className="user-list-container">
        <div className="user-list">
          {users.map(user => (
            <div key={user.id} className="user-card">
              <div
                className={`user-avatar ${user.gender}`}
                onMouseDown={() => handlePressStart(user)}
                onMouseUp={handlePressEnd}
                onMouseLeave={handlePressEnd}
                onTouchStart={() => handlePressStart(user)}
                onTouchEnd={handlePressEnd}
                onTouchCancel={handlePressEnd}
              >
                <svg viewBox="0 0 24 24">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>

              <div className="user-info">
                <div className="user-name">{user.name}</div>
                <div className="user-school">{user.school}</div>
              </div>

              <div className="user-actions">
                <button
                  className="btn-outline"
                  onClick={() => handleViewReport(user.id)}
                >
                  视力报告
                </button>
                <button
                  className="btn-outline"
                  onClick={() => handleBookAppointment(user.id)}
                >
                  预约挂号
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="add-user-section">
          <button className="btn-add-user" onClick={handleAddUser}>
            <span className="add-icon">+</span> 添加其他学生
          </button>
          <p className="tips-text">长按头像解绑</p>
        </div>
      </div>

      <Modal
        visible={showModal}
        title="提示"
        message={`是否要与【${userToUnbind?.name}】解绑`}
        onCancel={() => setShowModal(false)}
        onConfirm={handleUnbind}
      />
    </div>
  );
};

export default UserListPage;
